import React, { useState, useMemo } from "react";
import { EditNiftyRegimeConfigModal } from "./EditNiftyRegimeConfigModal";
import { ChevronsUpDownIcon } from "lucide-react";

const NiftyRegimeConfigDataTable = ({ niftyRegimeConfigData, handleEditNiftyLotConfig }) => {
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: null
  });

  // Sort the data based on current sort configuration
  const sortedData = useMemo(() => {
    if (!sortConfig.key || !sortConfig.direction) {
      return niftyRegimeConfigData;
    }

    const sortableData = [...niftyRegimeConfigData];
    
    sortableData.sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      // Handle null/undefined values
      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return sortConfig.direction === 'asc' ? -1 : 1;
      if (bValue == null) return sortConfig.direction === 'asc' ? 1 : -1;

      // Convert to strings for comparison if they're not numbers
      const aStr = String(aValue).toLowerCase();
      const bStr = String(bValue).toLowerCase();
      
      // Try to parse as numbers for numeric sorting
      const aNum = parseFloat(aValue);
      const bNum = parseFloat(bValue);
      
      // If both are valid numbers, sort numerically
      if (!isNaN(aNum) && !isNaN(bNum)) {
        if (sortConfig.direction === 'asc') {
          return aNum - bNum;
        }
        return bNum - aNum;
      }
      
      // Otherwise, sort as strings
      if (sortConfig.direction === 'asc') {
        if (aStr < bStr) return -1;
        if (aStr > bStr) return 1;
        return 0;
      } else {
        if (aStr > bStr) return -1;
        if (aStr < bStr) return 1;
        return 0;
      }
    });

    return sortableData;
  }, [niftyRegimeConfigData, sortConfig]);

  const handleSort = (key) => {
    let direction = 'asc';
    
    if (sortConfig.key === key) {
      if (sortConfig.direction === 'asc') {
        direction = 'desc';
      } else if (sortConfig.direction === 'desc') {
        direction = null;
        setSortConfig({ key: null, direction: null });
        return;
      }
    }
    
    setSortConfig({ key, direction });
  };

    const getSortIcon = (columnKey) => {
      
        return (
          <span className="inline-block ml-1 text-white">
                    <ChevronsUpDownIcon className="h-3 w-3 text-white" />
                  </span>
        );
      
      
     
    };

  const generateRows = (dataArray) => {
    return dataArray.map((item, index) => (
      <tr
        key={index}
        className="bg-black z-0 border-b last-of-type:border-b-0 border-gray-900 font-medium text-white hover:bg-black/90"
      >
        {Object.values(item).map((value, idx) => (
          <td
            key={idx}
            className={`px-4 py-2 border-r last-of-type:border-r-0 border-gray-900
              ${value > 0 ? 'bg-emerald-500' : ''}
            `}
          >
            {value}
          </td>
        ))}
        <td
          key="actions"
          className="text-center px-4 py-2 border-r last-of-type:border-r-0 border-gray-900"
        >
          <EditNiftyRegimeConfigModal rowData={item} handleEditNiftyLotConfig={handleEditNiftyLotConfig} />
        </td>
      </tr>
    ));
  };

  const generateTables = (dataArray) => {
    return (
      <div className="z-0 w-full h-[calc(100vh-140px)] overflow-auto custom-scroll animate-reveal transition-all duration-500 ease-in">
        {dataArray.length > 0 ? (
          <table className="bg-black  text-sm w-full relative z-0 overflow-x-auto">
            <thead className="bg-[#0F0F0F] sticky top-0 h-[40px] text-sm text-left">
              <tr className="text-white border-b border-gray-800">
                {Object.keys(dataArray[0]).map((header, idx) => (
                  <th
                    key={idx}
                    className="border-r last-of-type:border-r-0 border-gray-800 px-2 py-3 font-semibold cursor-pointer hover:bg-gray-800 transition-colors duration-200 select-none"
                    onClick={() => handleSort(header)}
                  >
                    <div className="flex items-center justify-between">
                      <span>{header}</span>
                      {getSortIcon(header)}
                    </div>
                  </th>
                ))}
                <th
                  key="actions-header"
                  className="border-r text-center last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>{generateRows(dataArray)}</tbody>
          </table>
        ) : (
          <h3 className="flex items-center text-gray-300 text-md font-medium uppercase">
            No Data Available
          </h3>
        )}
      </div>
    );
  };

  return (
    <div className="grid grid-cols-1  overflow-y-auto w-full ">
      {generateTables(sortedData)}
    </div>
  );
};

export default NiftyRegimeConfigDataTable;




























































// import React from "react";
// import { EditNiftyRegimeConfigModal } from "./EditNiftyRegimeConfigModal";


// const NiftyRegimeConfigDataTable = ({ niftyRegimeConfigData ,handleEditNiftyLotConfig }) => {

//   const generateRows = (dataArray) => {
//     return dataArray.map((item, index) => (
//       <tr
//         key={index}
//         className="bg-black z-0 border-b last-of-type:border-b-0 border-gray-900 font-medium text-white hover:bg-black/90"
//       >
//         {Object.values(item).map((value, idx) => (
//           <td
//             key={idx}
//             className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900"
//           >
//             {value}
//           </td>
//         ))}
//         <td
//           key="actions"
//           className="text-center px-4 py-2 border-r last-of-type:border-r-0 border-gray-900"
//         >
//           <EditNiftyRegimeConfigModal rowData={item} handleEditNiftyLotConfig={handleEditNiftyLotConfig} />
//         </td>
//       </tr>
//     ));
//   };

 
//   const generateTables = (dataArray) => {
//     return (
//       <div className="z-0 w-full h-full animate-reveal transition-all duration-500 ease-in">
//         {dataArray.length > 0 ? (
//           <table className="bg-black border border-gray-700 text-sm w-full relative z-0">
//             <thead className="bg-[#0F0F0F] text-sm text-left">
//               <tr className="text-white border-b border-gray-800">
//                 {Object.keys(dataArray[0]).map((header, idx) => (
//                   <th
//                     key={idx}
//                     className="border-r last-of-type:border-r-0 border-gray-800 px-2 py-3 font-semibold"
//                   >
//                     {header}
//                   </th>
//                 ))}
//                 <th
//                   key="actions-header"
//                   className="border-r text-center last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold"
//                 >
//                   Action
//                 </th>
//               </tr>
//             </thead>
//             <tbody>{generateRows(dataArray)}</tbody>
//           </table>
//         ) : (
//           <h3 className="flex items-center text-gray-300 text-md font-medium uppercase">
//             No Data Available
//           </h3>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="grid grid-cols-1 h-[calc(100vh-130px)]  overflow-y-auto  w-full  px-6">
//       {generateTables(niftyRegimeConfigData)}
//     </div>
//   );
// };

// export default NiftyRegimeConfigDataTable;
